export enum AnalyticEvents {
  SiteOpened = 'site_opened',
}
